/**
 * 文件上传工具函数
 */
import { ElMessage } from 'element-plus'
import { showLoginModal } from './emitter'
import { useI18n } from '~/composables/useI18n'
import { LOGIN_ENTRY_ENABLED } from './feature-flags'

/**
 * 上传文件到S3
 * @param file 文件对象
 * @returns S3 URL
 */
export const uploadToS3 = async (file: File): Promise<string> => {
    const config = useRuntimeConfig()
    const token =
        typeof localStorage !== 'undefined' ? localStorage.getItem('token') : ''
    // 语言跟随“当前 URL 的 i18n locale”，不要从偏好/老的 localStorage('language') 读取
    let language = 'en'
    try {
        const { locale } = useI18n()
        if (locale?.value) language = locale.value
    } catch {
        // 忽略，兜底 en
    }
    const baseUrl = config.public.apiBase
    const appKey = config.public.appKey
    const uploadUrl = `${baseUrl}/api/v1/auth/s3/upload_images?app_key=${appKey}`

    const formData = new FormData()
    formData.append('files', file)

    const response = await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
        credentials: 'include',
        headers: {
            Authorization: token || '',
            'Accept-Language': language,
        },
    })

    const result = await response.json()

    if (result.status === 200) {
        return result.data.object_url_list[0]
    } else if ([1005, 4001, 4002].includes(result.status)) {
        if (LOGIN_ENTRY_ENABLED) {
            showLoginModal()
        } else {
            ElMessage.error(result.message || result.desc || '您当前未登录')
        }
        throw new Error('请先登录')
    } else {
        throw new Error(result.message || result.desc || '上传失败')
    }
}
